import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col, FormGroup } from "reactstrap";
import Select from 'react-select'
import Loader from '../Loader/Loader'

const options = {
    plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
    },
    scales: {
        y: {
            ticks: {
                padding: 0,
                color: "#9f9f9f",
                beginAtZero: false,
                maxTicksLimit: 10,
            },
            grid: {
                drawBorder: true,
                display: false,
            },
        },
        x: {
            barPercentage: 1.6,
            grid: {
                drawBorder: true,
                display: false,
            },
            ticks: {
                padding: 0,
                color: "#9f9f9f",
                maxTicksLimit: 50
            },
        },
    },
}
class ChartRevenue extends Component {
    constructor(props) {
        super(props);
        this.year = ""
        this.product = ""
        this.state = {
            data: [],
            isLoading: true,
            productsList: [],
            product: "",
            yearsList: [],
        };
    }
    loadStats6() {
        if (this.year !== "" && this.product !== "") {
            this.setState({ isLoading: true })
            return fetch('https://tdb.confotex.com/api/orders-stats-6/', {
                method: 'POST',
                headers: {
                    'authorization': window.sessionStorage.getItem('session_token'),
                    "x-my-custom-header": window.sessionStorage.getItem('iduser'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    year: this.year.value,
                    id_prod: this.product.value,
                })
            })
                .then((reponse) => reponse.json())
                .then((data) => {
                    console.log(data);
                    if (data.reponse === "true") {


                        this.setState({ data: data.stats, isLoading: false })

                    } else if (data.reponse === "false") {
                        this.showNotification(data)
                    }
                    else {
                        this.setState({ isLoading: false })
                    }
                })
                .catch((error) => console.error(error));
        }
    }
    loadProducts() {
        return fetch('https://tdb.confotex.com/api/products/', {
            method: 'GET',
            headers: {
                'authorization': window.sessionStorage.getItem('session_token'),
                "x-my-custom-header": window.sessionStorage.getItem('iduser'),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then((reponse) => reponse.json())
            .then((data) => {
                if (data.reponse === "true") {

                    let array = []
                    data.productsList.forEach(element => {
                        let obj = {}
                        obj.value = element.id_prod
                        obj.label = element.nom_prod
                        array.push(obj)
                    });

                    this.setState({ productsList: array, isLoading: false })

                } else if (data.reponse === "false") {
                    this.showNotification(data)
                }
                else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((error) => console.error(error));
    }
    generateYears() {
        let max = new Date().getFullYear()
        let array = []
        for (let i = 2020; i <= max; i++) {
            let obj = {}
            obj.value = i
            obj.label = i
            array.push(obj)
        }
        this.setState({ yearsList: array })
    }
    componentDidMount() {
        this.loadProducts()
        this.generateYears()
    }
    render() {
        return (
            <>
                <Row>
                    <Col md="4">
                        <Card >
                            <CardBody className="justify-content-center d-flex">
                                <table className="table-sm table-hover table-responsive" style={{ height: 400, }}>
                                    <thead>
                                        <th>Mois</th>
                                        <th>Qte Contrôlée</th>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.data.map((value, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{value}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="8">
                        <Card>
                            {/* DISPLAY LOADER */}
                            {this.state.isLoading && <div style={{ backgroundColor: "white", position: 'absolute', height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 99, borderRadius: 15 }}>
                                <Loader />
                            </div>}
                            <CardHeader>
                                <CardTitle tag="h5">Variation de production d'un produit par mois</CardTitle>
                                <CardHeader>
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <label>
                                                    Produit
                                                </label>
                                                <Select value={this.state.product} options={this.state.productsList} onChange={(event) => { this.product = event; this.setState({ product: event }); this.loadStats6() }} isSearchable={false} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label>
                                                    Année
                                                </label>
                                                <Select value={this.state.year} options={this.state.yearsList} onChange={(event) => { this.year = event; this.loadStats6() }} isSearchable={false} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardHeader>
                            </CardHeader>
                            <CardBody>
                                <Bar
                                    data={(canvas) => {
                                        return {
                                            labels: ['Jan.', 'Fév', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Aout', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
                                            datasets: [
                                                {
                                                    borderColor: "white",
                                                    backgroundColor: '#5499C7',
                                                    pointRadius: 0,
                                                    pointHoverRadius: 0,
                                                    borderWidth: 1,
                                                    tension: 0.4,
                                                    fill: true,
                                                    data: this.state.data
                                                }
                                            ],
                                        };
                                    }}
                                    options={options}
                                    width={400}
                                    height={100}
                                />
                            </CardBody>
                            <CardFooter>
                                <hr />
                                <div className="stats" onClick={() => { this.loadStats6() }}>
                                    <i className="fas fa-history" /> Actualiser
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>

                </Row>

            </>

        );
    }
}

export default ChartRevenue;
